import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axiosClient from '../../../components/api/axiosClient';
import LoadContentSpinner from '../../../components/Utils/LoadContentSpinner';
import DashboardPromoMarker from '../../../components/Utils/DashboardPromoMarker';
import { useError } from '../../../components/contexts/ErrorContext';

export default function PromotionsList() {
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [emptyMessage, setEmptyMessage] = useState(null);
    const { handleError } = useError();

    useEffect(() => {
        setLoading(true);
        axiosClient
            .get('/dashboard/promotions/events')
            .then((response) => {
                if (response.data.noContent) {
                    setEmptyMessage(response.data.message || 'Aucun événement publié disponible.');
                    setEvents([]);
                } else {
                    setEvents(response.data.data || []);
                    setEmptyMessage(null);
                }
            })
            .catch(() => {
                handleError('Impossible de charger vos événements pour les promotions.');
            })
            .finally(() => setLoading(false));
    }, [handleError]);

    return (
        <div className="ch3yp cnbwt cs7xl clu2m c6btv clbq0 cxsfz">
            <div className="c2g1r cwnq4 cnlq0 c6r0l">
                <div className="c2rn6 cdiog">
                    <h1 className="text-gray-800 dark:text-gray-100 font-bold c459m cbtcb">
                        Promotions tarifaires
                    </h1>
                    <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
                        Baissez temporairement le prix d’un billet (ex. 5&nbsp;000 → 4&nbsp;100 XOF). Le prix catalogue reste inchangé.
                    </p>
                </div>
            </div>

            {loading ? (
                <LoadContentSpinner />
            ) : emptyMessage ? (
                <div className="rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 p-6 text-gray-600 dark:text-gray-300">
                    {emptyMessage}
                </div>
            ) : (
                <div className="overflow-x-auto rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800">
                    <table className="min-w-full text-sm">
                        <thead className="bg-gray-50 dark:bg-gray-900/40 text-left text-gray-500">
                            <tr>
                                <th className="px-4 py-3 font-medium">Événement</th>
                                <th className="px-4 py-3 font-medium">Date</th>
                                <th className="px-4 py-3 font-medium">Billets</th>
                                <th className="px-4 py-3 font-medium">Promos actives</th>
                                <th className="px-4 py-3 font-medium" />
                            </tr>
                        </thead>
                        <tbody>
                            {events.map((event) => (
                                <tr key={event.id} className="border-t border-gray-100 dark:border-gray-700">
                                    <td className="px-4 py-3 text-gray-800 dark:text-gray-100 font-medium">
                                        <div className="flex flex-wrap items-center gap-2">
                                            <span>{event.name}</span>
                                            <DashboardPromoMarker
                                                eventId={event.id}
                                                hasActivePromo={event.active_promotions_count > 0}
                                                activeCount={event.active_promotions_count}
                                            />
                                        </div>
                                    </td>
                                    <td className="px-4 py-3 text-gray-600 dark:text-gray-300">
                                        {event.date || '—'} {event.hour ? `· ${event.hour}` : ''}
                                    </td>
                                    <td className="px-4 py-3 text-gray-600 dark:text-gray-300">
                                        {event.tickets_count}
                                    </td>
                                    <td className="px-4 py-3">
                                        {event.active_promotions_count > 0 ? (
                                            <span className="inline-flex rounded-full bg-emerald-100 text-emerald-800 px-2 py-0.5 text-xs font-medium">
                                                {event.active_promotions_count}
                                            </span>
                                        ) : (
                                            <span className="text-gray-400">0</span>
                                        )}
                                    </td>
                                    <td className="px-4 py-3 text-right">
                                        <Link
                                            to={`/dashboard/communiquer/promotions/event/${event.id}`}
                                            className="btn bg-primary-6000 hover:bg-primary-700 text-white text-xs px-3 py-2 rounded-md"
                                        >
                                            Gérer
                                        </Link>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}
